import { render, staticRenderFns } from "./SecureDocModal.vue?vue&type=template&id=7ee5bf50&"
import script from "./SecureDocModal.vue?vue&type=script&lang=js&"
export * from "./SecureDocModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports